import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';

export default class PuzzleModel extends EventDispatcher {

    constructor(location, allowFail, sequence, rule, timings, timer, currentSequence) {
        super();
        this.location = location;
        this.allowFail = allowFail;
        this.timings = timings;
        this.sequence = sequence;
        this.rule = rule;
        this.currentSequence = currentSequence;
        this.timer = timer;

        this.reset();
    }

    hasNextSequence() {
        return (this.currentSequence + 1 < this.sequence.length ? true : false);
    }

    getCurrentSequence() {
        return this.sequence[this.currentSequence];
    }

    getCurrentRuleId() {
        return this.rule.id[this.currentSequence];
    }

    pickSpot(spot) {
        this._pickedSpots.push(spot);
    }

    unpickSpot(spot) {
        this._pickedSpots.remove(spot);
    }

    get sampleFishVariation() {
        var ruleIdLastChar = this.getCurrentRuleId().slice(this.getCurrentRuleId().length - 1);
        if ("ABCDEF".includes(ruleIdLastChar)) {
            return { amount: 1, pattern: ruleIdLastChar };

        } else {
            return null;
        }
    }

    get pickedSpots() {
        return this._pickedSpots;
    }

    get lastPickedSpot() {
        if (this._pickedSpots.length < 1) { return null };

        return this._pickedSpots[this._pickedSpots.length - 1];
    }

    reset() {
        this._pickedSpots = [];
        this._requiredInput = [...this.rule.correctInput[this.currentSequence]];
    }


    validate() {
        //Just compare picked with required
        const picked = this._pickedSpots.map(spot => spot.id);
        const required = this._requiredInput;
        //  Sort both lists in the same way, if order is not important
        if (!this.rule.correctOrderRequired) {
            picked.sort((s1, s2) => s1 - s2);
            required.sort((s1, s2) => s1 - s2);
        }
        return picked.join(",") == required.join(",");
    }


    /*****************************
     *      SAVEGAME RELATED
     *****************************/

    toObject() {
        return {};
    }

    setFromObject(object) {
    }
}